import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Calendar as ReactCalendar } from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './index.sass';

const Calendar = ({ className, value, onChange, maxRangeToSelect }) => {
	const [lastClickedDate, setLastClickedDate] = useState([]);
	const handleChange = useCallback(
		(val) => {
			if (Array.isArray(val) && val.length === 2 && val[0] && val[1]) {
				const start = new Date(val[0].setHours(0,0,0,0));
				const end = new Date(val[1].setHours(0,0,0,0));
				const diffTime = Math.abs(end - start);
				const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;

				if (diffDays > maxRangeToSelect) {
					let lastClicked = null;
					const prev = Array.isArray(lastClickedDate) ? lastClickedDate : [lastClickedDate];
					lastClicked = val.find(date => !prev.some(prevDate => prevDate && date && prevDate.getTime() === date.getTime()));

					setLastClickedDate(lastClicked);
					onChange(lastClicked);
					return
				}
			}
			setLastClickedDate(val);
			onChange(val)
		},
		[onChange, maxRangeToSelect, lastClickedDate]
	);

	return (
	<ReactCalendar
		className={`Calendar ${className}`}
		locale="pt-BR"
		value={value}
			onChange={handleChange}
		next2Label={null}
		prev2Label={null}
			selectRange={maxRangeToSelect > 1}
		allowPartialRange
		maxDate={new Date()}
	/>
	);
};

Calendar.propTypes = {
	className: PropTypes.string,
	value: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.instanceOf(Date)),
		PropTypes.instanceOf(Date)
	]),
	onChange: PropTypes.func,
	maxRangeToSelect: PropTypes.number,
};

Calendar.defaultProps = {
	className: '',
	value: null,
	onChange: () => {},
	maxRangeToSelect: 1,
};

export default Calendar;
